import React, { useState } from "react";
import { ELightPath } from "../../../../Model/CaptureProfile";
import { CartesianCoordinate } from "../../../../Model/Coordinate";
import { ObjectiveCalibration } from "../../../../Model/ImagerCalibration";
import { getModuleState } from "../../../../redux/reducers/ModuleStateReducer";
import { useTypedSelector } from "../../../../redux/reducers/RootReducer";
import CommandPanel from "../../../CommandPanel/CommandPanel";
import ServicingTable from "../../../Common/ServicingTable";
import ImagerManualControl from "../../../Imager/ImagerManualControl";
import Disabled from "../../../Controls/Disabled";

type Props = {
  disabled?: boolean;
  imagerIdentifier: string;
  lightPath: ELightPath;
  backBtn: () => void;
  imagerIdentifiersWithObjectiveZoom: string[];
  objectiveOffset: ObjectiveCalibration[];
  setObjectiveOffset: (objectiveOffset: ObjectiveCalibration[]) => void;
};

export default function ObjectiveOffset({
  disabled,
  backBtn,
  imagerIdentifier,
  objectiveOffset,
  setObjectiveOffset,
}: Props) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const moduleState = useTypedSelector((state) =>
    getModuleState(state, imagerIdentifier)
  );

  const imagerState = moduleState.imager;
  if (imagerState == null) {
    throw new Error("Imager state is null");
  }

  const updateOffset = (coordinate: CartesianCoordinate) => {
    const newObjectiveOffset = [...objectiveOffset];
    newObjectiveOffset[selectedIndex] = {
      ...objectiveOffset[selectedIndex],
      offset: coordinate,
    };
    setObjectiveOffset(newObjectiveOffset);
  };

  const data = React.useMemo(
    () =>
      objectiveOffset.map((objective, idx) => ({
        name: objective.value + "X",
        x: objective.offset.x,
        y: objective.offset.y,
        z: objective.offset.z,
        id: idx.toString(),
        selected: idx === selectedIndex,
      })),
    [objectiveOffset, selectedIndex]
  );

  console.log("SERVICING_TABLE", { data });

  return (
    <CommandPanel
      style={{
        overflowY: "auto",
        WebkitBoxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        MozBoxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      }}
    >
      <CommandPanel.DarkBackArrowHeader
        title="Objective Offsets"
        onBackArrowClick={backBtn}
        style={{
          height: 60,
        }}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Disabled disabled={disabled}>
          <ServicingTable
            imagerIdentifier={imagerIdentifier}
            imagerState={imagerState}
            dropNumber={0}
            onDropNumberChanged={() => {}}
            maxDrop={0}
            data={data}
            onRowSelected={(row) => setSelectedIndex(Number.parseInt(row.id))}
            onRowUpdated={(row) =>
              updateOffset({
                x: row.x,
                y: row.y,
                z: row.z,
              })
            }
          />
        </Disabled>

        <ImagerManualControl
          wellLimitEnabled={false}
          imagerIdentifier={imagerIdentifier}
        />
      </div>
    </CommandPanel>
  );
}
